import { useEffect, useState } from "react";
import "./DeleteModal.css";
import { Box } from "@mui/material";
import Title from "../title/Title";
import {
  PrimaryButton,
  SecondaryButton,
} from "../buttonComponent/ButtonComponent";
import ActivateIcon from "./img/activateIcon.svg";
import DeactivateIcon from "./img/deactivateIcon.svg";
import ModalCloseButton from "./ModalCloseButton";
import { formatCapitalize } from "../../config/utilities/formatCapitalize";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#FFFFFF",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  p: 0,
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
};

const DeactivationModal = ({
  loading,
  isOpen,
  onClose,
  onToggle,
  itemName,
  action,
  module,
}) => {
  if (!isOpen) return null;

  const [title, setTitle] = useState("");
  const [mainText, setMainText] = useState("");

  useEffect(() => {
    if (module === "stops") {
      setTitle(`${formatCapitalize(action)} Stop`);
      setMainText(itemName.name);
    } else if (module === "trips") {
      setTitle(`${formatCapitalize(action)} Trip`);
      setMainText(itemName.name);
    } else if (module === "drivers") {
      setTitle(`${formatCapitalize(action)} Driver`);
      setMainText(itemName.name);
    } else if (module === "vehicles") {
      setTitle(`${formatCapitalize(action)} Vehicle`);
      setMainText(itemName.vehicleNumber);
    } else if (module === "serviceAnnouncement") {
      setTitle(`${formatCapitalize(action)} Service Announcement`);
      setMainText(itemName.title);
    } else if (module === "busPolicy") {
      setTitle(`${formatCapitalize(action)} Bus Policy`);
      setMainText(itemName.title);
    } else if (module === "generalPolicy") {
      setTitle(`${formatCapitalize(action)} General Policy`);
      setMainText(itemName.title);
    }
  }, [module]);

  return (
    <div className="modal-backdrop">
      <Box sx={style}>
        <div>
          <div className="modal-header-content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <img
                loading="lazy"
                src={action === "activate" ? ActivateIcon : DeactivateIcon}
                alt="invite-users-icon"
              />
              <ModalCloseButton onClick={onClose} />
            </div>
            <Title
              title={title}
              deleteSubtitle
              titleSize="1.125rem"
              subtitleSize="0.875rem"
              gap="0rem"
              lineHeight="2rem"
            >
              Are you sure you would like to{" "}
              <strong>
                {action === "activate" ? "activate" : "deactivate"} {mainText}?
              </strong>
            </Title>
          </div>
          <div className="button-container-delete">
            <SecondaryButton
              label="Cancel"
              width="170px"
              imageIcon={false}
              onClickFunction={onClose}
            />
            <PrimaryButton
              loading={loading}
              label="Confirm"
              width="170px"
              disable={false}
              onClickFunction={() => onToggle(action)}
            />
          </div>
        </div>
      </Box>
    </div>
  );
};

export default DeactivationModal;
